import { render, staticRenderFns } from "./dashboardUpdatesWithQuill.vue?vue&type=template&id=d547ed16&scoped=true&"
import script from "./dashboardUpdatesWithQuill.vue?vue&type=script&lang=js&"
export * from "./dashboardUpdatesWithQuill.vue?vue&type=script&lang=js&"
import style0 from "./dashboardUpdatesWithQuill.vue?vue&type=style&index=0&id=d547ed16&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d547ed16",
  null
  
)

export default component.exports